// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { ElectricMetersListComponent } from 'src/app/modules/electric-meters/pages/electric-meters-list/electric-meters-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: ElectricMetersListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadPropertiesList']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class ElectricMetersRoutingModule { }
